import React, { useContext, useState } from 'react'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import { SkycityContext } from '../../lib/SkycityProvider'
import Params from './Params.js'

import { error } from '@react/react-spectrum/Toast'
import Button from '@react/react-spectrum/Button'

import axios from 'axios'

import { colligoAsyncCall } from '../../lib/ccApi.js'
import {
    getFilename,
    getFilenameWithoutExt,
    getTempDirectory,
    getColligoHeaders
} from '../../lib/skycity.js'

import {
    exploreIndexDocument,
    exploreHomeDirectory,
    uploadFile,
    retrieveRendition,
    retrievePreSignedDownloadUrl
} from '../../lib/acpApi.js'
const LinkHeader = require('http-link-header')
const uuid = require('uuid/v4')


export default function Operation (files) {
    const {
        inputFiles,
        errorOptions,
        dispatch
    } = useContext(SkycityContext)

    const [params, setParams] = useState({
        serviceMode: [
            { label: 'Mask', value: 'mask', selected: true },
            { label: 'Cutout', value: 'cutout', selected: false }
        ],
        maskFormat: [
            { label: 'JPEG', value: 'jpeg', selected: true },
            { label: 'PNG', value: 'png', selected: false },
            { label: 'WEBP', value: 'webp', selected: false }
            // { label: 'JXL', value: 'jxl', selected: false }
        ],
        trim: false,
        softMask: true,
        backgroundColor: 'white',
        colorDecontamination: false,
        multipleMasks: false,
        includeBbox: false,
        postprocessEdge: false
    })

    function formatParams (params) {
        const mode = params.serviceMode.find((mode) => mode.selected).value
        const outputFormat = params.maskFormat.find((format) => format.selected).value
        const trim = params.trim
        const softMask = params.softMask
        const backgroundColor = params.backgroundColor
        const colorDecontamination = params.colorDecontamination
        const multipleMasks = params.multipleMasks
        const includeBbox = params.includeBbox
        const postprocessEdge = params.postprocessEdge
        return {
            mode: mode,
            output_format: outputFormat,
            trim: trim,
            soft_mask: softMask,
            background_color: backgroundColor,
            color_decontamination: colorDecontamination,
            multiple_masks: multipleMasks,
            include_bbox: includeBbox,
            postprocess_edge: postprocessEdge
        }
    }

    async function start (curFile) {
        const formattedParams = formatParams(params)
        const codePayload = {
            image: {
                name: 'input_image'
            },
            mode: formattedParams.mode,
            output_format: formattedParams.output_format,
            trim: formattedParams.trim,
            soft_mask: formattedParams.soft_mask,
            background_color: formattedParams.background_color,
            color_decontamination: formattedParams.color_decontamination,
            multiple_masks: formattedParams.multiple_masks,
            include_bbox: formattedParams.include_bbox,
            postprocess_edge: formattedParams.postprocess_edge
        }

        const formData = new FormData()
        // Download image to bytes
        const response = await fetch(curFile.path)
        const inputBlob = await response.blob()
        const fileObject = new File([inputBlob], 'input_image', { type: inputBlob.type })
        formData.append('request', JSON.stringify(codePayload))
        formData.append('input_image', fileObject)

        const config = {
            url: `${process.env.REACT_APP_CONFIG_ENDPOINT_MLCOLLIGO}/v1/masking/select-subject-async`,
            jobUrl: `${process.env.REACT_APP_CONFIG_ENDPOINT_MLCOLLIGO}`,
            method: 'POST',
            mode: 'cors',
            timeout: 90000,
            headers: getColligoHeaders(),
            payload: codePayload,
            body: {
                formData: formData
            }
        }

        /* *********************************** */
        dispatch({ type: 'set-codes', payload: { config: config } })

        const { metadata, images } = await colligoAsyncCall(config, formattedParams.output_format)
        console.log(`Received ${images.length} mask images`)

        // Process all images
        const processImagePromises = images.map(async (maskImage, index) => {
            // Create unique filename for each mask
            let outputFileName
            if (images.length > 1) {
                // For multiple masks, add index to filename
                outputFileName = `selectsubjectv5_${uuid()}_${curFile.shortName}_mask${index}.${maskImage.format}`
            } else {
                outputFileName = `selectsubjectv5_${uuid()}_${curFile.shortName}.${formattedParams.output_format}`
            }

            const newFile = new File([maskImage.blob], outputFileName, { type: maskImage.contentType })

            // Upload file object to CC storage
            const outputHref = `${getTempDirectory()}/${outputFileName}`

            // 1. Explore the Index Document and get the Primary URL of the home Directory
            const homeDirectoryPrimaryUrl = await exploreIndexDocument()

            // 2. Explore the home Directory and get the Create URL of the Cloud Documents Directory
            const exploreHomeDirectoryResponse = await exploreHomeDirectory(
                homeDirectoryPrimaryUrl
            )
            const cloudDocumentsCreateUrl = exploreHomeDirectoryResponse.createLink
            const fileUploaded = await uploadFile(
                cloudDocumentsCreateUrl,
                newFile
            )
            const uploadlinks = LinkHeader.parse(fileUploaded.headers.get('link'))
            const primaryUrl = uploadlinks.refs.filter(val => val.rel.match('http://ns.adobe.com/adobecloud/rel/primary'))[0].uri
            const renditionUrl = uploadlinks.refs.filter(val => val.rel.match('http://ns.adobe.com/adobecloud/rel/rendition'))[0].uri
            const largeRendition = await retrieveRendition(
                renditionUrl,
                0,
                maskImage.contentType
            ) || URL.createObjectURL(maskImage.blob)
            const preSignedDownloadUrl = await retrievePreSignedDownloadUrl(primaryUrl)
            console.log('preSignedDownloadUrl', preSignedDownloadUrl)

            return {
                inputFile: curFile,
                name: getFilename(outputHref),
                shortName: getFilenameWithoutExt(outputHref),
                path: outputHref,
                outputThumbnail: largeRendition,
                output: largeRendition,
                outputToDownload: preSignedDownloadUrl,
                maskIndex: index,
                maskName: maskImage.name || `mask${index}`,
                maskFilename: maskImage.filename
            }
        })
        const processedImages = await Promise.all(processImagePromises)

        // Skycity library to be updated for response
        if (files.find(file => file.inputFile === curFile)) {
            return
        }

        // Add all processed images to files array
        files.push(...processedImages)

        dispatch({
            type: 'skycity-success',
            payload: {
                files: files,
                response: metadata,
                loading: false,
                wait: false
            }
        })
    }

    async function run (e) {
        try {
            dispatch({ type: 'skycity-run', payload: {} })

            files = []
            const funcArray = []
            inputFiles.forEach(curFile => {
                funcArray.push(start(curFile))
            })
            await axios.all(funcArray)
        } catch (e) {
            errorOccured(`${__('error_msg_title')}: ${e.stack}`)
        }
    }

    function isRunDisabled () {
        if (inputFiles && inputFiles.length > 0) {
            return false
        }
        return true
    }

    function errorOccured (errMsg, res) {
        console.log(errMsg)
        error(errMsg.slice(0, errorOptions.wordSlice), {
            onClose: () => console.log('close'),
            timeout: errorOptions.msgTimeout
        })
        dispatch({ type: 'error-occured', payload: { errMsg: errMsg, response: res, loading: false, wait: false } })
    }

    try {
        return <div>
            <Params params={params} setParams={setParams} />
            <div className="adobe-skycity-button-right">
                <Button variant="cta" onClick={e => run(e)} disabled={isRunDisabled()}>{__('btn_run')}</Button>
            </div>
        </div>
    } catch (e) {
        console.log(e)
        error(`${__('error_msg_title')}: ${e}`, {
            timeout: 0
        })
    }
}
